import { Navbar } from "~/components/company/Navbar"
import { Footer } from "~/components/company/Footer"

interface CompanyLayoutProps {
  children: React.ReactNode
}

export function CompanyLayout({ children }: CompanyLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1 pt-16">
        {children}
      </main>
      <Footer />
    </div>
  )
}
